const qs = require('query-string')

function getDefaultState() {
  return {
    restaurants: [],
    active_restaurants: []
  }
}
import axios from 'axios'
import ElementUI from 'element-ui'
export default {
  namespaced: true,
  state: {
    restaurants: [],
    active_restaurants: []
  },
  getters: {
    restaurants(state) {
      return state.restaurants
    },
    activeRestaurants(state) {
      return state.active_restaurants
    }
  },
  mutations: {
    setRestaurants(state, data) {
      state.restaurants = data
    },
    setActiveRestaurants(state, data) {
      state.active_restaurants = data
    },
    clearState(state) {
      Object.assign(state, getDefaultState())
    }
  },
  actions: {
    async getMyRestaurants({ commit }, query) {
      await axios
        .get(`/restaurants` + `?${qs.stringify(query)}`)
        .then((response) => {
          commit('setRestaurants', response.data.data)
        })
        .catch((error) => {
          console.log('catch : error :' + error)
        })
    },
    async getActiveRestaurants({ commit }, data) {
      const req = require('querystring').stringify(data)
      await axios
        .get('/restaurants/active?' + req)
        .then((response) => {
          if (response.data) {
            commit('setActiveRestaurants', response.data.data)
          } else {
            commit('setActiveRestaurants', [])
          }
        })
        .catch((error) => {
          console.log('catch : error :' + error)
        })
    },
    async createRestaurants({ dispatch }, data) {
      const title = navigator.language === 'ja' ? '成功' : 'Success'
      const message = navigator.language === 'ja' ? 'ブランドの追加に成功しました。' : 'Success to add the brand.'
      await axios
        .post('/restaurants', data)
        .then(() => {
          ElementUI.MessageBox.alert(message, title, { dangerouslyUseHTMLString: false, confirmButtonText: 'OK' })
          dispatch('getMyRestaurants')
        })
        .catch((error) => {
          console.log('catch : error :' + error)
        })
    },
    async editRestaurants({ dispatch }, data) {
      const title = navigator.language === 'ja' ? '成功' : 'Success'
      const message = navigator.language === 'ja' ? '編集に成功しました。' : 'Success to edit'
      await axios
        .put('/restaurants', data)
        .then(() => {
          ElementUI.MessageBox.alert(message, title, { dangerouslyUseHTMLString: false, confirmButtonText: 'OK' })
          dispatch('getMyRestaurants')
        })
        .catch((error) => {
          console.log('catch : error :' + error)
        })
    },
    async deleteRestaurant({ dispatch }, id) {
      const title = navigator.language === 'ja' ? '成功' : 'Success'
      const message = navigator.language === 'ja' ? 'ブランドの削除に成功しました。' : 'Success to delete the brand.'
      await axios
        .delete('/restaurants', { params: { restaurant_id: id } })
        .then(() => {
          ElementUI.MessageBox.alert(message, title, { dangerouslyUseHTMLString: false, confirmButtonText: 'OK' })
          dispatch('getMyRestaurants')
        })
        .catch((error) => {
          console.log('catch : error :' + error)
        })
    },
    clearState({ commit }) {
      commit('clearState')
    }
  }
}
